<script>
import { mapState } from 'vuex';
import TopNavbar from "../../pages/banner/index.vue";
import DashboardContent from "./Content.vue";
import SideBar from "./Sidebar.vue";
import AuditorSidebar from "./AuditorSidebar.vue";
export default {
  components: {
    TopNavbar,
    DashboardContent,
    SideBar,
    AuditorSidebar,
  },

  computed : {
    ...mapState('app', [
      'adminPanel',
      'companyLicence',
      'navbarOpen',
    ]),

    isOnStakeholdersPage() {
      if (this.$route.name === "User Operations") {
        return true;
      } else {
        return false;
      }
    },

    isAuditor() {
      if (!this.companyLicence.plan_id) return false;
      return this.companyLicence.plan_id === -1;
    },

    navbarState() {
      return this.navbarOpen;
    }
  },
};
</script>

<template>
  
  <div class="app-router-wrapper">
      <top-navbar class="navbar-wrapper" />
      <div class="app-bottom-content-wrapper">
        <side-bar 
          v-if="adminPanel === false && isAuditor === false"  
          class="side-bar-wrapper"
          :class="{
            'side-bar-flex': navbarState,
          }"
        />
        <auditor-sidebar 
          v-if="adminPanel === false && isAuditor === true"  
          class="side-bar-wrapper"
          :class="{
            'side-bar-flex': navbarState,
          }"
        />
        <dashboard-content 
          class="app-main-content" 
          :style="{
            'padding': adminPanel ? `0 !important` : `1em 2.5em`,
          }" 
          :class="{
            'dashboard-on-admin-panel': adminPanel,
            'app-main-content-flex': navbarState
          }"
        >
        </dashboard-content>
      </div>
  </div>
  
</template>

<style lang="scss">
  .app-router-wrapper {
    width: 100vw;
    height: 100vh;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    overflow: hidden;
  }

  .navbar-wrapper {
    width: 100%;
    height: 100px; 
    min-height: 100px; 
    max-height: 100px; 
    background-color: whitesmoke; 
    overflow: visible; 
  }

  .app-bottom-content-wrapper {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    overflow: hidden;
  }

  .side-bar-wrapper {
    background-color: #d4dddf;
  }

  .side-bar-flex {
    flex: 1;
  }

  .app-main-content {
    background-color: #d4dddf;
    padding-bottom: 100px;
    overflow-y: scroll; 
    overflow-x: hidden; 
  }

  .app-main-content-flex {
    flex: 15;
  }

  .dashboard-on-admin-panel {
    transform: translateX(-1px);
  }

  .leftbar{
    background-color: #023047;
    overflow-x: hidden;
  }

  .leftbar::-webkit-scrollbar{
    margin: 0;
    width: 5px;
    background: aliceblue;
  }
  .leftbar::-webkit-scrollbar-thumb{
    background: #035a86;
  }

  .content::-webkit-scrollbar{
    width: 10px;
    background: #d4dddf;
  }
  .content::-webkit-scrollbar-thumb{
    background: #035178;
  }

</style>